import * as types from './types';

const initialState = {
  upload: 0,
  latency: 0,
  download: 0,
  offline_disclo: null,
  offline_announ: null,
};

const networkReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_UPLOAD_SPEED:
      return { ...state, upload: action.payload };

    case types.SAVING_OFFLINE_DISCLO:
      return { ...state, offline_disclo: action.payload };

    case types.SAVING_OFFLINE_ANNOUN:
      return { ...state, offline_announ: action.payload };

    case types.RESET_DATA_DISCLOSURES:
      return { ...state, offline_disclo: null };

    case types.RESET_DATA_ANNOUNCEMENTS:
      return { ...state, offline_announ: null };
    default:
      return state;
  }
};

export default networkReducer;
